import { selectIsFeatureEnabled } from 'tradera/state/environment/selectors';
import { selectIsDanishVisitor } from 'tradera/state/shipping-region/selectors';

export const selectIsGoogleAdsEnabled = (state) =>
    !selectIsDanishVisitor(state) &&
    selectIsFeatureEnabled('google-ads')(state);

export const selectIsTcfLoaded = (state) => state.ads.isTcfLoaded;
